import { render } from "./bigIndex.vue?vue&type=template&id=ccdbd0f4&scoped=true"
import script from "./bigIndex.vue?vue&type=script&lang=js"
export * from "./bigIndex.vue?vue&type=script&lang=js"

import "./bigIndex.vue?vue&type=style&index=0&id=ccdbd0f4&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccdbd0f4"]])

export default __exports__